import { render, staticRenderFns } from "./review-order.vue?vue&type=template&id=37fcfc0a&scoped=true"
import script from "./review-order.vue?vue&type=script&lang=js"
export * from "./review-order.vue?vue&type=script&lang=js"
import style0 from "./review-order.vue?vue&type=style&index=0&id=37fcfc0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fcfc0a",
  null
  
)

export default component.exports